import axios from 'axios';
import TicketModel from '../models/TicketModel';
import apiService from './apiService';
import moment from 'moment';

export default {
  async getTicketsApi(userId = '', eventId = '') {
    // const urlBase = 'https://api.temporadaemmovimento.com.br';
    //
    try {
      const _options = {
        // url: `${urlBase}/events/${eventId}/logins/${userId}/logistics`,
        url: `${process.env.REACT_APP_BASE_URL}/events/${eventId}/logins/${userId}/logistics`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const _ret = await axios(_options);

      let _return = [
        {
          id: '',
          tktNumber: '',
          provider: '',
          origin: '',
          destin: '',
          dateOrigin: '',
          dateDestin: '',
          type: '', // air, transfer, hotel
          obs1: '',
          obs2: '',
        },
      ];

      _return = [];
      if (!_ret || !_ret.data || !_ret.data.findAllLogisticsData) {
        console.log(_ret);
        return _return;
      }

      for (const item of _ret.data.findAllLogisticsData) {
        let _obj;

        if (item.type === 'flight') {
          _obj = getAirObj(item);
        } else if (item.type === 'hotel') {
          _obj = getHotelObj(item);
        } else {
          _obj = getTransferObj(item);
        }

        _return.push(_obj);
      }

      _return.sort((a, b) =>
        a.dateOrigin > b.dateOrigin ? 1 : b.dateOrigin > a.dateOrigin ? -1 : 0
      );

      return _return;
    } catch (error) {
      console.log('Error getTicketsApi', error);
      throw error;
    }
    function getAirObj(data) {
      try {
        return {
          id: data.id || '',
          tktNumber: data.locator || '',
          provider: data.company || '',
          origin: data.origin || '',
          destin: data.destination || '',
          dateOrigin: `${data.boardingdate || ''}T${data.boardingtill || ''}`,
          dateDestin: `${data.arrivaldate || ''}T${data.arrivaltime || ''}`,
          type: 'air',
          obs1: data.seat || '',
          obs2: data.locator || '',
          flightnumber: data.flightnumber || '',
          eticket: data.eticket || '',
        };
      } catch (error) {
        console.log('Error getAirObj', error);
        throw error;
      }
    }

    function getHotelObj(data) {
      try {
        return {
          id: data.id || '',
          tktNumber: '',
          provider: data.hotel || '',
          origin: '',
          destin: '',
          dateOrigin: `${data.checkindate || ''}T${data.checkintime || ''}`,
          dateDestin: `${data.checkoutdate || ''}T${data.ckeckouttime || ''}`,
          type: 'hotel',
          obs1: data.address || '',
          obs2: '',
        };
      } catch (error) {
        console.log('Error getHotelObj', error);
        throw error;
      }
    }

    function getTransferObj(data) {
      try {
        return {
          id: data.id || '',
          tktNumber: '',
          provider: data.company || '',
          origin: data.origin || '',
          destin: data.destination || '',
          dateOrigin: `${data.boardingdate || ''}T${data.boardingtill || ''}`,
          dateDestin: `${data.arrivaldate || ''}T${data.arrivaltime || ''}`,
          type: 'transfer',
          obs1: data.drivername || '',
          obs2: data.driverphone || '',
        };
      } catch (error) {
        console.log('Error getTransferObj', error);
        throw error;
      }
    }
  },

  async getLogisticsInteegraPlus(eventId = '', userId = '') {
    try {
      const _options = {
        url: `${apiService.getUrl().logistics}events/${eventId}/logins/${userId}/logistics`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const _ret = await axios(_options);

      let _return = [TicketModel()];
      _return = [];

      for (let i = 0; i < _ret.data.length; i++) {
        let _obj;

        if (_ret.data[i].type === 'flight') {
          _obj = getAirObj(_ret.data[i], i);
        } else if (_ret.data[i].type === 'hotel') {
          _obj = getHotelObj(_ret.data[i], i);
        } else {
          _obj = getTransferObj(_ret.data[i], i);
        }

        _return.push(_obj);
      }

      _return.sort((a, b) => (a.dateOrigin > b.dateOrigin ? 1 : b.dateOrigin > a.dateOrigin ? -1 : 0));

      return _return;
    } catch (error) {
      console.log('Error getLogisticsInteegraPlus', error);
      throw error;
    }

    function getAirObj(data, i) {
      try {
        return TicketModel({
          id: i.toString(),
          tktNumber: data.eticket || data.locator || '',
          provider: data.company || '',
          origin: data.origin || '',
          destin: data.destination || '',
          dateOrigin: moment(`${data.boardingdate} ${data.boardingtill || ''}`, 'YYYY-MM-DD HH:mm').toISOString(),
          dateDestin: moment(`${data.arrivaldate} ${data.arrivaltime || ''}`, 'YYYY-MM-DD HH:mm').toISOString(),
          type: 'air',
          obs1: data.seat || '',
          obs2: data.flightnumber || '',
        });
      } catch (error) {
        console.log('Error getAirObj', error);
        throw error;
      }
    }

    function getHotelObj(data, i) {
      try {
        return TicketModel({
          id: i.toString(),
          tktNumber: '',
          provider: data.hotel || '',
          origin: '',
          destin: '',
          dateOrigin: moment(`${data.checkindate} ${data.checkintime || ''}`, 'YYYY-MM-DD HH:mm').toISOString(),
          dateDestin: moment(`${data.checkoutdate} ${data.ckeckouttime || ''}`, 'YYYY-MM-DD HH:mm').toISOString(),
          type: 'hotel',
          obs1: data.address || '',
          obs2: '',
        });
      } catch (error) {
        console.log('Error getHotelObj', error);
        throw error;
      }
    }

    function getTransferObj(data, i) {
      try {
        return TicketModel({
          id: i.toString(),
          tktNumber: '',
          provider: data.company || '',
          origin: data.origin || '',
          destin: data.destination || '',
          dateOrigin: moment(`${data.boardingdate} ${data.boardingtill || ''}`, 'YYYY-MM-DD HH:mm').toISOString(),
          dateDestin: moment(`${data.boardingdate} ${data.horaOut || data.boardingtill || ''}`, 'YYYY-MM-DD HH:mm').toISOString(),
          type: 'transfer',
          obs1: data.drivername || '',
          obs2: data.driverphone || '',
        });
      } catch (error) {
        console.log('Error getTransferObj', error);
        throw error;
      }
    }
  }
}
